import axios from "axios";

const accesstoken = sessionStorage.getItem('accesstoken');

export default axios.create({
    baseURL: process.env.REACT_APP_TMS_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'X-Tms-Token': process.env.REACT_APP_TMS_CONNECTION_KEY,
        'Authorization': `Bearer ${accesstoken}`,
    }
});